import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Suspense as _Suspense, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mr-2" }
const _hoisted_2 = { class: "text-bluegray-300" }
const _hoisted_3 = { class: "p-fluid" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = {
  class: "pb-3",
  style: {"height":"calc(245px + 15px)","padding-bottom":"15px"}
}
const _hoisted_9 = { class: "card m-0 pb-0 shadow-none" }
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = {
  key: 0,
  class: "col"
}
const _hoisted_12 = { class: "mb-3 text-xs text-center" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "mb-3 text-xs text-center" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "mb-3 text-xs text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldCheckbox = _resolveComponent("FieldCheckbox")!
  const _component_FieldDropdownAutoCompleteMultiple = _resolveComponent("FieldDropdownAutoCompleteMultiple")!
  const _component_FiltersSidebar = _resolveComponent("FiltersSidebar")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_Feed = _resolveComponent("Feed")!
  const _component_Chartist = _resolveComponent("Chartist")!
  const _component_PrimeVueVirtualScroller = _resolveComponent("PrimeVueVirtualScroller")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "mb-3",
      title: `👩‍💻 ${_ctx.$t('feeds_activity')}`,
      "show-refresh-button": "",
      "refresh-button-handler": _ctx.fetchStatisticsWrapper,
      "refresh-button-loading": _ctx.statisticsLoading,
      "show-filters-button": "",
      "show-filters": _ctx.showStatisticsFilters,
      "onUpdate:showFilters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showStatisticsFilters) = $event)),
      loading: _ctx.statisticsLoading
    }, {
      title: _withCtx(() => [
        _createElementVNode("h1", {
          class: "mb-0",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.test && _ctx.test(...args)))
        }, [
          _createElementVNode("span", _hoisted_1, "👨‍💻 " + _toDisplayString(_ctx.$t('feeds_activity')), 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('for_last')) + " " + _toDisplayString(_ctx.statisticsFilters.hour_offset) + " " + _toDisplayString(_ctx.$t('hours_abbr')), 1)
        ])
      ]),
      _: 1
    }, 8, ["title", "refresh-button-handler", "refresh-button-loading", "show-filters", "loading"]),
    _createVNode(_component_FiltersSidebar, {
      visible: _ctx.showStatisticsFilters,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showStatisticsFilters) = $event)),
      "apply-button-handler": _ctx.fetchStatisticsWrapper,
      "apply-button-loading": _ctx.statisticsLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.statisticsFilters.hour_offset,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statisticsFilters.hour_offset) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('hours_interval'),
            options: _ctx.hourOffsetOptions
          }, null, 8, ["modelValue", "label", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FieldCheckbox, {
            modelValue: _ctx.statisticsFilters.show_feeds_requests,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statisticsFilters.show_feeds_requests) = $event)),
            label: "Show requests 🐢"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.statisticsFilters.traffic_type,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.statisticsFilters.traffic_type) = $event)),
            label: _ctx.$t('traffic_type'),
            options: _ctx.TRAFFIC_TYPES,
            "show-clear": "",
            multiple: ""
          }, null, 8, ["modelValue", "label", "options"])
        ]),
        (_ctx.user.isSuperAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.statisticsFilters.project_id,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.statisticsFilters.project_id) = $event)),
                  _ctx.onProjectChange
                ],
                label: _ctx.$t('project'),
                loading: _ctx.projectsLoading,
                options: _ctx.projects.data,
                "option-value": "id",
                "option-label": "name",
                multiple: ""
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FieldDropdownAutoCompleteMultiple, {
            modelValue: _ctx.statisticsFilters.feed_id,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.statisticsFilters.feed_id) = $event)),
            label: _ctx.$t('feed'),
            "api-url": "/api/v3/feeds/options",
            "api-params": _ctx.feedsParams,
            "option-label": "compiled_name"
          }, null, 8, ["modelValue", "label", "api-params"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "apply-button-handler", "apply-button-loading"]),
    (_ctx.statisticsLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (index) => {
          return _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-3",
            key: index,
            height: "25px"
          })
        }), 64))
      : (_openBlock(), _createBlock(_component_PrimeVueVirtualScroller, {
          key: 1,
          items: _ctx.statistics.data,
          "item-size": 245 + 15,
          "num-tolerated-items": 10,
          "auto-size": "",
          "show-spacer": false
        }, {
          item: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Feed, {
                      class: "mb-3",
                      feed: item.feed,
                      "show-comment": false,
                      style: {"height":"50px"}
                    }, null, 8, ["feed"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, {
                      class: "mb-3",
                      height: "50px"
                    })
                  ]),
                  _: 2
                }, 1024)),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.statisticsFilters.show_feeds_requests)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('requests')), 1),
                              (_openBlock(), _createBlock(_component_Chartist, {
                                class: "activity-chart activity-chart-blue",
                                key: `chart-${item.feed.id}-requests`,
                                "axis-y-label-interpolation-function": _ctx.axisYLabelInterpolationFunction,
                                entries: item.series.requests,
                                style: {"height":"125px"}
                              }, null, 8, ["axis-y-label-interpolation-function", "entries"]))
                            ])
                          ]),
                          fallback: _withCtx(() => [
                            _createVNode(_component_PrimeVueSkeleton, {
                              class: "mb-3",
                              height: "125px"
                            })
                          ]),
                          _: 2
                        }, 1024))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(), _createBlock(_Suspense, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('clicks')), 1),
                          (_openBlock(), _createBlock(_component_Chartist, {
                            class: "activity-chart activity-chart-blue",
                            key: `chart-${item.feed.id}-clicks`,
                            "axis-y-label-interpolation-function": _ctx.axisYLabelInterpolationFunction,
                            entries: item.series.clicks,
                            style: {"height":"125px"}
                          }, null, 8, ["axis-y-label-interpolation-function", "entries"]))
                        ])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, {
                          class: "mb-3",
                          height: "125px"
                        })
                      ]),
                      _: 2
                    }, 1024))
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(), _createBlock(_Suspense, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('revenue')), 1),
                          (_openBlock(), _createBlock(_component_Chartist, {
                            class: "activity-chart activity-chart-blue",
                            key: `chart-${item.feed.id}-revenue`,
                            "axis-y-label-interpolation-function": _ctx.axisYLabelInterpolationFunctionRevenue,
                            entries: item.series.revenue,
                            style: {"height":"125px"}
                          }, null, 8, ["axis-y-label-interpolation-function", "entries"]))
                        ])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, {
                          class: "mb-3",
                          height: "125px"
                        })
                      ]),
                      _: 2
                    }, 1024))
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["items"]))
  ], 64))
}